import './polyfills'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppContainer } from './containers';
import './styles/index.css';
import './styles/App.css'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppContainer/>);